import { render } from "./ModalInformativoDisclaimer.vue?vue&type=template&id=4f3d14aa"
import script from "./ModalInformativoDisclaimer.vue?vue&type=script&lang=js"
export * from "./ModalInformativoDisclaimer.vue?vue&type=script&lang=js"

import "./ModalInformativoDisclaimer.vue?vue&type=style&index=0&id=4f3d14aa&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__